export default __webpack_public_path__ + "static/media/Whitepaper-BG.0200aac7.png";